import { Tab } from '../../../../../modals/product/ProductModal';

export default {
  title: 'Nyt produkt',
  tabs: {
    [Tab.General]: 'Generelt',
    [Tab.NutritionInfo]: 'Næringsindhold',
  },
  form: {
    categories: {
      label: 'Kategorier',
    },
    printer: {
      label: 'Printer',
    },
    name: {
      label: 'Navn',
      placeholder: 'Cheeseburger',
    },
    description: {
      label: 'Beskrivelse',
      placeholder: '180 g oksekød, salat, tomater, agurker, jalapeños og yuppi-sauce',
    },
    external_id: {
      label: '{{integration}}-reference',
      placeholder: 'fx HubRise SKU-reference',
      read_only_hint:
        'Kan kun redigeres, mens en HubRise-integration er tilsluttet, og menusynkronisering er slået fra.',
    },
    price: {
      label: 'Grundpris',
    },
    has_smart_pricing: {
      label: 'Særpriser for afhentning og levering',
    },
    pickup_price: {
      label: 'Afhentningspris',
      placeholder: 'Ikke angivet',
    },
    delivery_price: {
      label: 'Leveringspris',
      placeholder: 'Ikke angivet',
    },
    image: {
      label: 'Billede (valgfrit)',
    },
    has_combo_tax: {
      label: 'Har kombiafgift',
    },
    is_available: {
      label: 'På lager',
      subtitle: 'Vises på menuen',
    },
    is_visible: {
      label: 'Synlig',
      title: 'Synlig på menuen',
      subtitle_on: 'Kunder kan se denne vare',
      subtitle_off: 'Skjult for alle kunder',
    },
    is_available_for_pickup: {
      label: 'Tilgængelig til afhentning',
      subtitle_on: 'Kunder kan bestille til afhentning',
      subtitle_off: 'Skjult fra afhentningsmenuen',
    },
    is_available_for_delivery: {
      label: 'Tilgængelig til levering',
      subtitle_on: 'Kunder kan bestille til levering',
      subtitle_off: 'Skjult fra leveringsmenuen',
    },
    modifiers: {
      label: 'Tilvalg',
    },
  },
  labels: {
    smart_pricing_update_warning:
      'Ved opdatering overskrives alle eksisterende smart pricing-regler for dette produkt.',
    smart_pricing_remove_warning: 'Efter lagring fjernes alle eksisterende smart pricing-regler for dette produkt.',
  },
  availability: {
    title: 'Tilgængelighed',
    helper:
      'Synlighed er hovedkontakten. Slå en kanal fra for at skjule varen for kunder med afhentning eller levering uden at fjerne den fra menuen.',
    status: {
      both: 'Begge kanaler',
      pickup_only: 'Kun afhentning',
      delivery_only: 'Kun levering',
      hidden: 'Skjult',
      no_channels: 'Ingen kanaler',
    },
    warning: {
      no_channels: 'Denne vare er synlig, men ikke tilgængelig på nogen kanaler – kunder kan ikke bestille den.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Kun afhentning',
      delivery_only: 'Kun levering',
      no_channels: 'Ingen kanaler',
    },
  },
  buttons: {
    save: 'Gem',
    close: 'Luk',
  },
  toasts: {
    changes_got_saved: 'Ændringerne blev gemt!',
  },
};
